import $ from 'jquery';

var $footerColumns = $('#footerColumns');

$footerColumns.find('.collapse').on('show.bs.collapse', function () {
    var $fa = $(this).prev('.column-header').find('.icon');

    if (!$fa.is(':visible')) {
        return false;
    }

    $fa.removeClass("fa-chevron-down").addClass("fa-chevron-up");
}).on('hide.bs.collapse', function () {
    var $fa = $(this).prev('.column-header').find('.icon');

    if (!$fa.is(':visible')) {
        return false;
    }

    $fa.removeClass("fa-chevron-up").addClass("fa-chevron-down");
});
